import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgGeoFenceService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    upsertGeoFenceConf(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "geoFenceId":1
        //     ,"listLatLng":[
        //         {
        //             "lat":"123.123456"
        //             ,"lng":"123.123456"
        //             ,"radius":"123.123456"
        //         }
        //     ]
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    listGeoFenceConf(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    listGeoFenceConfLoc(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/loc/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    listGeoFenceConfCar(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/car/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    deleteGeoFenceConfCar(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/car/delete";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    updateGeoFenceConfCar(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/car/update";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    listGeoFenceConfRoute(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/route/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    updateGeoFenceConfRouteOrder(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/route/order/update";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    deleteGeoFenceConfRouteOrder(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/route/order/delete";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertGeoFenceConfRouteOrder(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/manage/conf/route/order/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    listGeoFenceHis(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/his/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    selectGeoFenceHis(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/geofence";
        url += "/his/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}